import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

import FieldGroup from './FieldGroup';

export const RestrictedEmail = styled.div`
  box-sizing: border-box;
  height: 39px;
  overflow: hidden;
  padding: 10px 9px;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Offset FieldGroup negative margin. */
  margin-top: ${gridSize()}px;
`;

interface Props {
  value?: string;
}

const RestrictedEmailContainer = ({ value }: Props) => {
  return (
    <FieldGroup>
      <RestrictedEmail title={value}>{value}</RestrictedEmail>
      <input
        data-testid="restricted-email-container"
        autoComplete="username"
        type="hidden"
        name="username"
        value={value}
      />
    </FieldGroup>
  );
};

export default RestrictedEmailContainer;
